import { Contributor } from '../../models/Contributors';

export const types = {
  GET_CONTRIBUTORS_REQUEST: 'CONTRIBUTORS/GET_CONTRIBUTORS_REQUEST',
  GET_CONTRIBUTORS_SUCCESS: 'CONTRIBUTORS/GET_CONTRIBUTORS_SUCCESS',
  GET_CONTRIBUTORS_FAILURE: 'CONTRIBUTORS/GET_CONTRIBUTORS_FAILURE',
  UPDATE_CONTRIBUTORS_REQUEST: 'CONTRIBUTORS/UPDATE_CONTRIBUTORS_REQUEST',
  UPDATE_CONTRIBUTORS_SUCCESS: 'CONTRIBUTORS/UPDATE_CONTRIBUTORS_SUCCESS',
  UPDATE_CONTRIBUTORS_FAILURE: 'CONTRIBUTORS/UPDATE_CONTRIBUTORS_FAILURE',
  TOGGLE_TOAST: 'CONTRIBUTORS/TOGGLE_TOAST',
  TOGGLE_REMOVE_MODAL: 'CONTRIBUTORS/TOGGLE_REMOVE_MODAL',
  TOGGLE_OUTSIDE_MODAL: 'CONTRIBUTORS/TOGGLE_OUTSIDE_MODAL',
};

export const initialState = {
  error: null,
  isLoading: false,
  isUpdating: false,
  showToast: false,
  showRemoveModal: false,
  showOutsideModal: false,
  byUUID: {},
  contributor: undefined,
};

export interface Action {
  type: string;
  error?: string;
  contributors?: Contributor[];
  contributor?: Contributor;
  toggle?: boolean;
  add?: boolean;
  uuid?: string;
}

export default (state = initialState, action: Action) => {
  const { contributors, contributor, toggle, uuid } = action;
  switch (action.type) {
    case types.GET_CONTRIBUTORS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_CONTRIBUTORS_SUCCESS:
      if (uuid) {
        return {
          ...state,
          isLoading: false,
          byUUID: {
            ...state.byUUID,
            [uuid]: contributors,
          },
        };
      }
      return { ...state, isLoading: false };
    case types.GET_CONTRIBUTORS_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.UPDATE_CONTRIBUTORS_REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null,
        showRemoveModal: false,
        showToast: false,
        contributor: undefined,
      };
    case types.UPDATE_CONTRIBUTORS_SUCCESS:
      return { ...state, isUpdating: false, contributor, showToast: true };
    case types.UPDATE_CONTRIBUTORS_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.TOGGLE_TOAST:
      return { ...state, showToast: toggle, contributor };
    case types.TOGGLE_REMOVE_MODAL:
      return { ...state, showRemoveModal: toggle, contributor };
    case types.TOGGLE_OUTSIDE_MODAL:
      return { ...state, showOutsideModal: toggle };
    default:
      return state;
  }
};

export const actions = {
  fetchContributors: (organizationUUID: string) => ({
    type: types.GET_CONTRIBUTORS_REQUEST,
    organizationUUID,
  }),
  updateContributors: (
    organizationUUID: string,
    add: boolean,
    contributor: Contributor
  ) => ({
    type: types.UPDATE_CONTRIBUTORS_REQUEST,
    organizationUUID,
    add,
    contributor,
  }),
  toggleToast: (toggle: boolean, contributor: Contributor) => ({
    type: types.TOGGLE_TOAST,
    toggle,
    contributor,
  }),
  toggleRemoveModal: (toggle: boolean, contributor?: Contributor) => ({
    type: types.TOGGLE_REMOVE_MODAL,
    toggle,
    contributor,
  }),
  toggleOutsideModal: (toggle: boolean) => ({
    type: types.TOGGLE_OUTSIDE_MODAL,
    toggle,
  }),
};

export const selectors = {
  contributorsByUUID: (state: any, uuid: string) => {
    return state.contributors.byUUID[uuid];
  },
};
